import { Box, BoxProps, Theme } from '@mui/material';
import { Component } from 'react';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

type overflowTypes = 'auto' | 'hidden' | 'scroll' | 'visible' | 'initial' | 'inherit';

const styles = (theme: Theme) =>
    createStyles({
        backgroundLight: {
            '&::-webkit-scrollbar-track': {
                background: theme.scrollbars.backgroundColor,
                borderRadius: theme.scrollbars.borderRadius,
            },
        },
        backgroundDark: {
            '&::-webkit-scrollbar-track': {
                background: theme.scrollbars.backgroundColorDark,
                borderRadius: theme.scrollbars.borderRadius,
            },
        },
    });

interface PoolScrollbarProps extends WithStyles<typeof styles>, Omit<BoxProps, 'classes'> {
    overflowX?: overflowTypes;
    overflowY?: overflowTypes;
    darkBackground?: boolean;
}

export const PoolScrollbar = withStyles(styles)(
    class PoolScrollbarBase extends Component<PoolScrollbarProps> {
        public override render() {
            const { classes, children, className, overflowX, overflowY, darkBackground, ...rest } = this.props;

            const scrollbars = {
                overflowX: overflowX ? overflowX : 'auto',
                overflowY: overflowY ? overflowY : 'auto',
            };

            const scrollbarStyle = `${className} ${darkBackground ? classes.backgroundDark : classes.backgroundLight}`;

            return (
                <Box style={scrollbars} className={scrollbarStyle} {...rest}>
                    {children}
                </Box>
            );
        }
    }
);
